import React from "react";


export interface FieldHeaderProps {
    required?: boolean;
    inline?: boolean;
    complex?: boolean;
    name: string;
    description?: string;
    for?: string;
    customDescriptionClass?: string;
    customNameClass?: string; 
}


export class FieldHeader extends React.PureComponent<FieldHeaderProps> {
 
    render() {
        const { required, inline, complex, name, description, customDescriptionClass, customNameClass } = this.props;
        const className = 'field-header' + (complex ? ' field-complex-header' : '') +
            (required ? ' require' : '') + (inline ? ' inline-label' : '') +
            (customNameClass ? ' ' + customNameClass : '');
        const classNameDescription = 'field-description' + (customDescriptionClass ? ' ' + customDescriptionClass : '')
        return (<React.Fragment>
            <label className={className} htmlFor={this.props.for}>{name}</label><br />
            { description && description.length && customDescriptionClass === 'info-text' && <label className={classNameDescription} dangerouslySetInnerHTML={{ __html: description }} htmlFor={this.props.for}></label>}
            { description && description.length && customDescriptionClass !== 'info-text' && <label className={classNameDescription} htmlFor={this.props.for}>{description}</label> }
            </React.Fragment>);
    }
    
}
